import { t } from "@/i18n-js/instance";

export const TABS = {
  TAB_COMMUNITY: "tab_community",
  TAB_CUSTOM: "tab_custom",
};

export const TABS_LABELS = {
  [TABS.TAB_COMMUNITY]: t("settings.community_bot.knowledge.tab_community"),
  [TABS.TAB_CUSTOM]: t("settings.community_bot.knowledge.tab_custom"),
};

export const COMMUNITY_TYPE_OPTIONS = [
  {
    label: t("settings.community_bot.knowledge.type.course"),
    value: "course",
  },
  { label: t("settings.community_bot.knowledge.type.post"), value: "basic" },
];

export const CUSTOM_TYPE_OPTIONS = [
  {
    label: t("settings.community_bot.knowledge.custom.types.snippet"),
    value: "Snippet",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.pdf"),
    value: "PDF",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.txt"),
    value: "TXT",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.srt"),
    value: "SRT",
  },
];
